import { Fragment, useState, useEffect, useRef } from "react";
import Image from "next/image";
import { Props } from "./types";
import getConfig from "next/config";
import routes from "@/constants/routes";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

const ShareButton = ({ article }: Props) => {
  const [isCopied, setIsCopied] = useState(false);
  const [isOpened, setShareButtonBlockOpened] = useState(false);
  const { publicRuntimeConfig } = getConfig();
  const wrapperRef = useRef(null);

  const useOutsideAlerter = (ref: any) => {
    useEffect(() => {
      const handleClickOutside = (event: any) => {
        if (ref.current && !ref.current.contains(event.target)) {
          setShareButtonBlockOpened(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };

  const handleCopyClick = () => {
    navigator.clipboard.writeText(
      publicRuntimeConfig.NEXT_PUBLIC_URL + routes.blog + "/" + article.attributes.slug,
    );
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1500);
  };

  useOutsideAlerter(wrapperRef);

  return (
    <Fragment>
      <div ref={wrapperRef}>
        <div
          className="w-auto max-h-[30px] max-w-[30px] hover:cursor-pointer relative"
          onClick={() => setShareButtonBlockOpened(!isOpened)}
        >
          <Image src="/icons/share-button.svg" height={24} width={24} alt="icon" />
        </div>
        <div
          className={`${
            isOpened ? "flex flex-col" : "hidden"
          } bg-grey-900 rounded-lg absolute top-10 text-left left-[0] text-white text-sm leading-[17px] tracking-[-1.1%] pl-5 pr-12 md:pr-24 py-2.5 z-10`}
        >
          <div
            className={`${
              isCopied ? "flex" : "hidden"
            } bg-landing-cherry rounded-lg absolute -top-8 left-5 text-white p-5 z-20 w-fit min-w-fit`}
          >
            Link copied
          </div>
          <div className="font-bold text-[10px] leading-[13px] pb-3">SHARE</div>
          <div
            className="pb-4 hover:cursor-pointer"
            onClick={() => {
              handleCopyClick();
            }}
          >
            Copy link
          </div>
          <div className="pb-4 w-max">
            <FacebookShareButton
              url={
                publicRuntimeConfig.NEXT_PUBLIC_URL + routes.blog + "/" + article.attributes.slug
              }
            >
              Share on Facebook
            </FacebookShareButton>
          </div>
          <div className="pb-4">
            <TwitterShareButton
              url={
                publicRuntimeConfig.NEXT_PUBLIC_URL + routes.blog + "/" + article.attributes.slug
              }
              title={article.attributes.title}
              via="keyzyhomes"
            >
              Share on Twitter
            </TwitterShareButton>
          </div>
          <div>
            <LinkedinShareButton
              url={
                publicRuntimeConfig.NEXT_PUBLIC_URL + routes.blog + "/" + article.attributes.slug
              }
              summary={article.attributes.description}
              title={article.attributes.title}
            >
              Share on Linkedin
            </LinkedinShareButton>
          </div>
        </div>
        <div
          className={`origin-top-left ml-6 transform rotate-45 bg-grey-900  w-8 h-8 ${
            isOpened ? "flex" : "hidden"
          }`}
        ></div>
      </div>
    </Fragment>
  );
};
export default ShareButton;
